module.exports = __webpack_public_path__ + "img/gd_n1.1804110f.jpg";